'use es6';

import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H2 from 'UIComponents/elements/headings/H2';
import Big from 'UIComponents/elements/Big';
import UICardSection from 'UIComponents/card/UICardSection';
import { ProfileListing } from 'marketplace-ui-solutions-core/records/ProfileListing';
import ProfileCardWrapper from './ProfileCardWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AboutCard = ({
  profileListing
}) => {
  const {
    name,
    description
  } = profileListing;
  return /*#__PURE__*/_jsx(ProfileCardWrapper, {
    id: "about",
    children: /*#__PURE__*/_jsxs(UICardSection, {
      children: [/*#__PURE__*/_jsx(H2, {
        className: "is--heading-3",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ecosystem-marketplace-solutions-ui.profile.about",
          options: {
            name
          }
        })
      }), /*#__PURE__*/_jsx(Big, {
        style: {
          lineHeight: '28px',
          whiteSpace: 'pre-wrap'
        },
        children: description
      })]
    })
  });
};
AboutCard.propTypes = {
  profileListing: PropTypes.instanceOf(ProfileListing)
};
export default AboutCard;